import React from "react";

const defaultButton = props => <a {...props}>{props.children}</a>;

export default class Pagination extends React.Component {
  constructor(props) {
    super();

    this.changePage = this.changePage.bind(this);
    this.state = {
      visiblePages: this.getVisiblePages(props.page + 1, props.pages)
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.pages !== nextProps.pages) {
      this.setState({
        visiblePages: this.getVisiblePages(nextProps.page + 1, nextProps.pages)
      });
    }

    this.changePage(nextProps.page + 1);
  }

  filterPages = (visiblePages, totalPages) => {
    return visiblePages.filter(page => page <= totalPages);
  };

  getVisiblePages = (page, total) => {
    if (total <= 5) {
      return this.filterPages([1, 2, 3, 4, 5], total);
    } else {
      if (page >= 5) {
        if (page + 3 <= total) {
          return [1, page - 2, page - 1, page, page + 1, page + 2, total];
        }
        else {
          return this.filterPages([1, page - 2, page - 1, page, page + 1, page + 2], total);
        }
      }
      else {
        page = page ? page : 1;
        return [page - 3, page - 2, page - 1, page, page + 1, page + 2, total].filter(p => p >= 1).filter(p => p<= total);
      }
    }
  };

  changePage(page) {
    const activePage = this.props.page + 1;
    if (page === activePage) {
      return;
    }

    const visiblePages = this.getVisiblePages(page, this.props.pages);

    this.setState({
      visiblePages: this.filterPages(visiblePages, this.props.pages)
    });
    this.props.onPageChange(page - 1);
  }

  render() {
    const { PageButtonComponent = defaultButton } = this.props;
    const { visiblePages } = this.state;
    const activePage = this.props.page + 1;
    const totalRows = this.props.count;
    const firstRowShown = (activePage - 1) * this.props.defaultPageSize + 1;
    const lastRowToShow = activePage * this.props.defaultPageSize;
    const lastRowShown = lastRowToShow < totalRows ? lastRowToShow : totalRows;
    return (
      <nav className="pager">
        <div className="result-info">
            {firstRowShown}-{lastRowShown} {this.props.ofText} {totalRows}
        </div>
        <ul className="pager__items">
          <li className="pager__item pager__item--previous">
            { activePage === 1 ? (
              <span className="inactive">{this.props.previousText}</span>
              ) : (
              <PageButtonComponent
                onClick={() => {
                  if (activePage === 1) return;
                  this.changePage(activePage - 1);
                }}
              >
                {this.props.previousText}
              </PageButtonComponent>
              )}
          </li>
          {visiblePages.map((page, index, array) => {
            return (
              <li key={page} className={ activePage === page ? "pager__item is-active" : "pager__item" }>
                {array[index - 1] + 1 < page ? <span>...</span> : ''}

                {(page < 500) && (<PageButtonComponent
                  key={page}
                  className="pager-button"
                  onClick={this.changePage.bind(null, page)}
                >
                  {page}
                </PageButtonComponent>)}
              </li>
            );
          })}
          <li className="pager__item pager__item--next">
            { activePage === this.props.pages ? (
              <span className="inactive">{this.props.nextText}</span>
            ) : (
              <PageButtonComponent
                onClick={() => {
                  if (activePage === this.props.pages) return;
                  this.changePage(activePage + 1);
                }}
              >
                {this.props.nextText}
              </PageButtonComponent>
            )}
          </li>
        </ul>
      </nav>
    );
  }
}
